export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-grid-line', description: '浏览全部韩漫作品' },
  { slug: 'romance', name: '浪漫爱情', icon: 'ri-heart-line', description: '甜蜜动人的浪漫爱情漫画' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', description: '充满想象力的奇幻冒险漫画' },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line', description: '热血沸腾的动作战斗漫画' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常喜剧漫画' },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line', description: '扣人心弦的悬疑惊悚漫画' },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line', description: '深刻动人的都市剧情漫画' },
  { slug: 'bl', name: 'BL向', icon: 'ri-user-heart-line', description: '优质BL向漫画作品' },
];

export const comics = [
  {
    id: 1,
    title: '星光下的约定',
    author: '金秀雅',
    category: 'romance',
    tags: ['浪漫', '校园', '治愈'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romantic%20comic%20book%20cover%20illustration%2C%20young%20couple%20under%20starry%20night%20sky%2C%20soft%20pink%20and%20lavender%20tones%2C%20dreamy%20atmosphere%2C%20clean%20simple%20gradient%20background%2C%20professional%20webtoon%20cover%20design%2C%20elegant%20character%20art%2C%20high%20quality%20digital%20illustration%2C%20warm%20lighting%2C%20emotional%20romantic%20scene&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '高中时期的一次偶然相遇，让两个性格截然不同的人走到了一起。在星光璀璨的夜晚，他们许下了彼此的约定。多年后，命运再次将他们联系在一起...这是一段关于青春、梦想与爱情的故事。',
    rating: 4.8,
    views: 1258000,
    chapters: 86,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters_list: Array.from({ length: 86 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 命运的相遇' : i === 85 ? ' 星光下的誓言' : ''}`,
      updatedAt: new Date(2026, 7, 3 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
  },
  {
    id: 2,
    title: '暗影之王',
    author: '李正勋',
    category: 'action',
    tags: ['动作', '奇幻', '复仇'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20comic%20cover%2C%20dark%20warrior%20with%20shadow%20powers%2C%20dramatic%20pose%2C%20intense%20red%20and%20black%20color%20scheme%2C%20epic%20battle%20atmosphere%2C%20clean%20dark%20gradient%20background%2C%20professional%20webtoon%20cover%20art%2C%20dynamic%20character%20illustration%2C%20high%20quality%20digital%20art%2C%20powerful%20energy%20effects&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '在被最信任的人背叛后，曾经的王国骑士团长获得了操控暗影的力量。他从深渊中归来，踏上了复仇之路。然而，黑暗中隐藏的秘密远比他想象的更加庞大...',
    rating: 4.9,
    views: 2350000,
    chapters: 124,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters_list: Array.from({ length: 124 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 深渊觉醒' : i === 123 ? ' 最终决战' : ''}`,
      updatedAt: new Date(2026, 7, 3 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 3,
    title: '魔法学院日常',
    author: '朴智慧',
    category: 'fantasy',
    tags: ['奇幻', '学院', '成长'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20academy%20comic%20cover%2C%20magical%20school%20students%20in%20uniforms%2C%20floating%20spell%20books%20and%20magical%20effects%2C%20warm%20golden%20and%20emerald%20tones%2C%20enchanting%20atmosphere%2C%20clean%20medieval%20academy%20background%2C%20professional%20webtoon%20cover%20design%2C%20charming%20character%20art%2C%20high%20quality%20illustration%2C%20whimsical%20magical%20scene&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '一个普通女孩意外收到了魔法学院的录取通知书。在这里，她将遇到形形色色的同学，经历不可思议的冒险。魔法世界的日常，比想象中更加精彩！',
    rating: 4.6,
    views: 987000,
    chapters: 65,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters_list: Array.from({ length: 65 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 入学通知' : i === 64 ? ' 期末考验' : ''}`,
      updatedAt: new Date(2026, 7, 2 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
  },
  {
    id: 4,
    title: '办公室罗曼史',
    author: '郑恩珠',
    category: 'romance',
    tags: ['浪漫', '职场', '喜剧'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20comic%20cover%2C%20elegant%20business%20couple%20in%20modern%20office%2C%20soft%20warm%20beige%20and%20rose%20tones%2C%20sophisticated%20atmosphere%2C%20clean%20modern%20office%20background%2C%20professional%20webtoon%20cover%20design%2C%20mature%20character%20illustration%2C%20high%20quality%20digital%20art%2C%20romantic%20workplace%20scene%2C%20subtle%20emotional%20expression&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '职场精英和新人菜鸟，两个世界的人因为一个项目被分配到一起。从最初的摩擦到逐渐理解，办公室里的爱情故事悄然展开...',
    rating: 4.7,
    views: 1560000,
    chapters: 72,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters_list: Array.from({ length: 72 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 新来的实习生' : i === 71 ? ' 告白' : ''}`,
      updatedAt: new Date(2026, 7, 3 - Math.floor(i / 4)).toISOString().split('T')[0],
    })),
  },
  {
    id: 5,
    title: '鬼怪杂货铺',
    author: '尹智勋',
    category: 'thriller',
    tags: ['悬疑', '奇幻', '单元剧'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20thriller%20comic%20cover%2C%20mysterious%20antique%20shop%20with%20strange%20artifacts%2C%20eerie%20teal%20and%20dark%20purple%20tones%2C%20haunting%20atmosphere%2C%20clean%20dark%20mysterious%20background%2C%20professional%20webtoon%20cover%20design%2C%20intriguing%20character%20art%2C%20high%20quality%20digital%20illustration%2C%20supernatural%20mystery%20scene%2C%20subtle%20horror%20elements&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '城市深处有一家神秘的杂货铺，出售着各种奇异的物品。每个物品背后都有一个令人不寒而栗的故事。当你踏入这家店，你的命运便已被改写...',
    rating: 4.8,
    views: 890000,
    chapters: 48,
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters_list: Array.from({ length: 48 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 神秘店铺' : i === 47 ? ' 最后的交易' : ''}`,
      updatedAt: new Date(2026, 7, 1 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
  },
  {
    id: 6,
    title: '我的室友是吸血鬼',
    author: '韩素英',
    category: 'comedy',
    tags: ['搞笑', '奇幻', '日常'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20fantasy%20comic%20cover%2C%20funny%20vampire%20roommate%20in%20modern%20apartment%2C%20bright%20warm%20yellow%20and%20coral%20tones%2C%20lighthearted%20atmosphere%2C%20clean%20modern%20room%20background%2C%20professional%20webtoon%20cover%20design%2C%20humorous%20character%20expressions%2C%20high%20quality%20digital%20art%2C%20comedic%20daily%20life%20scene%2C%20playful%20energy&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '普通大学生租到了一间超便宜的房子，唯一的条件是：和房东的远房亲戚合住。然而这位"远房亲戚"竟然是一个活了300年的吸血鬼！爆笑的同居生活就此展开...',
    rating: 4.5,
    views: 2100000,
    chapters: 95,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters_list: Array.from({ length: 95 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 便宜的房间' : i === 94 ? ' 永恒的选择' : ''}`,
      updatedAt: new Date(2026, 7, 3 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 7,
    title: '逆天邪神',
    author: '崔武镇',
    category: 'action',
    tags: ['武侠', '玄幻', '热血'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20fantasy%20comic%20cover%2C%20powerful%20warrior%20with%20glowing%20sword%2C%20dramatic%20orange%20and%20gold%20energy%20effects%2C%20epic%20oriental%20fantasy%20atmosphere%2C%20clean%20ancient%20mountain%20background%2C%20professional%20webtoon%20cover%20design%2C%20intense%20character%20illustration%2C%20high%20quality%20digital%20art%2C%20action%20packed%20scene%2C%20divine%20power&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '废材少年偶然获得上古传承，从此踏上逆天改命之路。一剑破苍穹，一人敌万军。在这个强者为尊的世界里，他将书写属于自己的传奇！',
    rating: 4.9,
    views: 4520000,
    chapters: 156,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters_list: Array.from({ length: 156 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 废材少年' : i === 155 ? ' 逆天封神' : ''}`,
      updatedAt: new Date(2026, 7, 4 - Math.floor(i / 5)).toISOString().split('T')[0],
    })),
  },
  {
    id: 8,
    title: '城市之光',
    author: '姜美来',
    category: 'drama',
    tags: ['都市', '成长', '治愈'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20drama%20comic%20cover%2C%20young%20professional%20woman%20in%20city%20nightscape%2C%20warm%20golden%20city%20lights%2C%20emotional%20healing%20atmosphere%2C%20clean%20modern%20city%20background%2C%20professional%20webtoon%20cover%20design%2C%20realistic%20character%20portrait%2C%20high%20quality%20digital%20illustration%2C%20contemplative%20urban%20scene%2C%20soft%20bokeh%20effects&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '在大城市打拼的年轻人们，各自怀揣着梦想与伤痛。他们在城市的霓虹灯下相遇、离别、成长。这是一部关于都市青年生活的真实写照。',
    rating: 4.6,
    views: 765000,
    chapters: 54,
    status: '连载中',
    updatedAt: '2026-07-31',
    chapters_list: Array.from({ length: 54 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 初到首尔' : i === 53 ? ' 城市之光' : ''}`,
      updatedAt: new Date(2026, 6, 31 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
  },
  {
    id: 9,
    title: '花之契约',
    author: '柳恩浩',
    category: 'bl',
    tags: ['BL', '奇幻', '古风'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20fantasy%20historical%20comic%20cover%2C%20two%20elegant%20male%20characters%20with%20flower%20motifs%2C%20soft%20peach%20and%20lavender%20color%20palette%2C%20romantic%20ancient%20garden%20atmosphere%2C%20clean%20traditional%20Korean%20background%2C%20professional%20webtoon%20cover%20design%2C%20beautiful%20character%20art%2C%20high%20quality%20digital%20illustration%2C%20tender%20emotional%20scene%2C%20delicate%20floral%20elements&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '在古代宫廷中，花神与凡间少年缔结了神秘的花之契约。一段跨越人神界限的爱情，在繁花盛开的花园中悄然绽放。美丽的画面，动人的故事。',
    rating: 4.8,
    views: 1890000,
    chapters: 68,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters_list: Array.from({ length: 68 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 花神降临' : i === 67 ? ' 永恒的契约' : ''}`,
      updatedAt: new Date(2026, 7, 2 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
  },
  {
    id: 10,
    title: '末日生存指南',
    author: '安泰民',
    category: 'thriller',
    tags: ['末世', '生存', '悬疑'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20survival%20comic%20cover%2C%20survivors%20in%20ruined%20city%20landscape%2C%20desaturated%20gray%20and%20muted%20blue%20tones%2C%20intense%20survival%20atmosphere%2C%20clean%20destroyed%20city%20background%2C%20professional%20webtoon%20cover%20design%2C%20gritty%20character%20illustration%2C%20high%20quality%20digital%20art%2C%20dramatic%20survival%20scene%2C%20sense%20of%20urgency&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '一夜之间，世界变成了废墟。幸存者们必须在资源匮乏的环境中挣扎求生。然而，最大的威胁不仅仅是环境，还有人性在绝境中的扭曲...',
    rating: 4.7,
    views: 1340000,
    chapters: 42,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters_list: Array.from({ length: 42 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 末日降临' : i === 41 ? ' 希望曙光' : ''}`,
      updatedAt: new Date(2026, 7, 3 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 11,
    title: '甜点师与猫',
    author: '金秀雅',
    category: 'comedy',
    tags: ['治愈', '美食', '日常'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20healing%20comic%20cover%2C%20pastry%20chef%20with%20cute%20cats%20in%20cozy%20bakery%2C%20warm%20cream%20and%20soft%20brown%20tones%2C%20heartwarming%20atmosphere%2C%20clean%20cozy%20bakery%20background%2C%20professional%20webtoon%20cover%20design%2C%20adorable%20character%20and%20cat%20illustration%2C%20high%20quality%20digital%20art%2C%20sweet%20comfort%20scene%2C%20gentle%20happiness&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '一位甜点师在她的烘焙坊里收养了几只流浪猫。每天，她和猫咪们一起制作美味的甜点，治愈每一位顾客的心。温馨甜蜜的日常故事。',
    rating: 4.7,
    views: 678000,
    chapters: 36,
    status: '已完结',
    updatedAt: '2026-06-15',
    chapters_list: Array.from({ length: 36 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 面包店的新成员' : i === 35 ? ' 幸福的味道' : ''}`,
      updatedAt: new Date(2026, 5, 15 - i).toISOString().split('T')[0],
    })),
  },
  {
    id: 12,
    title: '时间的缝隙',
    author: '李正勋',
    category: 'fantasy',
    tags: ['时间', '穿越', '奇幻'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20time%20travel%20fantasy%20comic%20cover%2C%20mysterious%20clock%20and%20time%20portal%2C%20surreal%20indigo%20and%20silver%20tones%2C%20dreamlike%20atmosphere%2C%20clean%20cosmic%20abstract%20background%2C%20professional%20webtoon%20cover%20design%2C%20enigmatic%20character%20silhouette%2C%20high%20quality%20digital%20illustration%2C%20time%20manipulation%20scene%2C%20philosophical%20mood&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '一个能够看到时间缝隙的少年，意外发现自己可以穿梭于不同的时间线。每一次穿越都带来新的发现，也让他逐渐揭开了一个关于时间的巨大阴谋...',
    rating: 4.8,
    views: 1120000,
    chapters: 58,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters_list: Array.from({ length: 58 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 时间的裂缝' : ''}`,
      updatedAt: new Date(2026, 7, 4 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 13,
    title: '隐秘的复仇',
    author: '朴智慧',
    category: 'drama',
    tags: ['复仇', '悬疑', '都市'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20revenge%20drama%20comic%20cover%2C%20mysterious%20woman%20in%20dark%20elegant%20outfit%2C%20deep%20burgundy%20and%20charcoal%20tones%2C%20tense%20atmosphere%2C%20clean%20urban%20night%20background%2C%20professional%20webtoon%20cover%20design%2C%20intense%20character%20portrait%2C%20high%20quality%20digital%20art%2C%20psychological%20thriller%20mood%2C%20calculated%20expression&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    description: '十年前的一场阴谋毁掉了她的一切。如今她以全新的身份归来，精心策划了一场完美的复仇。然而，当真相逐渐浮出水面，她发现事情远没有那么简单...',
    rating: 4.6,
    views: 945000,
    chapters: 50,
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters_list: Array.from({ length: 50 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 归来的女人' : ''}`,
      updatedAt: new Date(2026, 7, 1 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
  },
  {
    id: 14,
    title: '剑与玫瑰',
    author: '韩素英',
    category: 'fantasy',
    tags: ['奇幻', '浪漫', '冒险'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20comic%20cover%2C%20female%20knight%20with%20sword%20surrounded%20by%20magical%20roses%2C%20soft%20crimson%20and%20emerald%20tones%2C%20romantic%20adventure%20atmosphere%2C%20clean%20enchanted%20forest%20background%2C%20professional%20webtoon%20cover%20design%2C%20beautiful%20warrior%20illustration%2C%20high%20quality%20digital%20art%2C%20epic%20fantasy%20scene%2C%20elegant%20power&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    description: '被选中的玫瑰骑士，肩负着保护王国的使命。在冒险途中，她遇到了神秘的剑客。剑与玫瑰的相遇，将改变整个王国的命运...',
    rating: 4.7,
    views: 1670000,
    chapters: 80,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters_list: Array.from({ length: 80 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 玫瑰骑士' : ''}`,
      updatedAt: new Date(2026, 7, 3 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
  },
  {
    id: 15,
    title: '心跳加速',
    author: '郑恩珠',
    category: 'romance',
    tags: ['浪漫', '校园', '青春'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20high%20school%20romance%20comic%20cover%2C%20young%20couple%20in%20school%20uniforms%20with%20cherry%20blossoms%2C%20soft%20pink%20and%20mint%20tones%2C%20sweet%20youthful%20atmosphere%2C%20clean%20school%20campus%20background%2C%20professional%20webtoon%20cover%20design%2C%20cute%20character%20art%2C%20high%20quality%20digital%20illustration%2C%20first%20love%20scene%2C%20spring%20breeze%20feeling&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    description: '总是考第一的学霸和爱玩的校草，看似毫无交集的两个人，在一次意外中交换了日记。从此，他们的高中生活变得不再平凡...',
    rating: 4.5,
    views: 1890000,
    chapters: 60,
    status: '已完结',
    updatedAt: '2026-05-20',
    chapters_list: Array.from({ length: 60 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 交换日记' : i === 59 ? ' 毕业典礼' : ''}`,
      updatedAt: new Date(2026, 4, 20 - i).toISOString().split('T')[0],
    })),
  },
  {
    id: 16,
    title: '野兽之血',
    author: '安泰民',
    category: 'action',
    tags: ['格斗', '热血', '成长'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fighting%20action%20comic%20cover%2C%20muscular%20fighter%20in%20dynamic%20combat%20pose%2C%20intense%20red%20and%20black%20energy%2C%20gritty%20underground%20arena%20atmosphere%2C%20clean%20dark%20fighting%20ring%20background%2C%20professional%20webtoon%20cover%20design%2C%20powerful%20character%20illustration%2C%20high%20quality%20digital%20art%2C%20fierce%20battle%20scene%2C%20raw%20strength&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    description: '地下格斗场的传奇人物，为了寻找失踪的妹妹，重新踏入血腥的格斗世界。每一场战斗都是生死较量，而他体内流淌的野兽之血正在觉醒...',
    rating: 4.8,
    views: 2780000,
    chapters: 110,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters_list: Array.from({ length: 110 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 地下格斗场' : ''}`,
      updatedAt: new Date(2026, 7, 4 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
  },
];

export const getComicsByCategory = (slug: string) => {
  if (slug === 'all') return comics;
  return comics.filter(c => c.category === slug);
};

export const getComicById = (id: number) => {
  return comics.find(c => c.id === id) || null;
};

export const getHotComics = () => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, 8);
};

export const getLatestComics = () => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 10);
};

export const getRankingComics = () => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, 10);
};